import React from "react";
import { Box, Flex, Spinner } from "theme-ui";

import { Dialog } from "./Dialog";

type WaitingDialogProps = {
  title: string;
  icon?: React.ReactNode;
  waitReason: React.ReactNode;
  cancelLabel?: string;
  onCancel: () => void;
};

export const WaitingDialog: React.FC<WaitingDialogProps> = ({
  title,
  icon,
  waitReason,
  cancelLabel,
  onCancel,
  children
}) => (
  <Dialog title={title} icon={icon} cancelLabel={cancelLabel} onCancel={onCancel}>
    {children}
    <Box sx={{ px: [3, 4], pb: [3, 4] }}>
      <div className="flex flex-row bg-card py-8 px-6">
        <Spinner size="3em" sx={{ mr: [0, 3], mb: [2, 0], color: 'gray' }} />
        <div className="flex flex-col items-start text-style-emphasize">
          {waitReason}
        </div>
      </div>
    </Box>
  </Dialog>
);
